import { render } from "./yiqi-dialog.vue?vue&type=template&id=1bb0dc48&scoped=true"
import script from "./yiqi-dialog.vue?vue&type=script&lang=js"
export * from "./yiqi-dialog.vue?vue&type=script&lang=js"

import "./yiqi-dialog.vue?vue&type=style&index=0&id=1bb0dc48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb0dc48"]])

export default __exports__